import { render, staticRenderFns } from "./FccSolicitacoesEspecificas.vue?vue&type=template&id=1697d509"
import script from "./FccSolicitacoesEspecificas.vue?vue&type=script&lang=js"
export * from "./FccSolicitacoesEspecificas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports